// Defines window.findPos
import './position.js';

(function () {
    function createFaqPopupClosure(el, faqContainerWidth) {
        return function () {
            displayFaqPopup(el, faqContainerWidth);
        };
    }

    let faqClosure = null;

    // Used in savedPayment.jsp as well as JS files, so needs to stay global for now
    // Everything else in this file is private
    window.getFaqPopup = function (el, faqURL) {
        let faqWidth = 350;
        if (window.isMobileView()) {
            faqWidth = 240;
        }
        getFaqPopupAndWidth(el, faqURL, faqWidth);
    };

    function getFaqPopupAndWidth(el, faqURL, faqContainerWidth) {
        if (document.getElementById('faqFrame') == null || document.getElementById('faqFrame') == null) {
            const faqFrame = document.createElement('iframe');
            faqFrame.setAttribute('id', 'faqFrame');
            faqFrame.setAttribute('name', 'faqFrame');
            faqFrame.setAttribute('width', '0');
            faqFrame.setAttribute('height', '0');
            faqFrame.setAttribute('frameBorder', '0');
            document.body.appendChild(faqFrame);
        }
        document.getElementById('faqFrame').src = setURLParam(faqURL, 'textOnly', 'true');
        if (faqClosure != null) eventRemove(document.getElementById('faqFrame'), 'load', faqClosure);
        faqClosure = createFaqPopupClosure(el, faqContainerWidth);
        eventPush(document.getElementById('faqFrame'), 'load', faqClosure);
    }

    function eventPush(obj, event, handler) {
        if (obj.addEventListener) {
            obj.addEventListener(event, handler, false);
        } else if (obj.attachEvent) {
            obj.attachEvent('on' + event, handler);
        }
    }

    function eventRemove(obj, event, handler) {
        if (obj.removeEventListener) {
            obj.removeEventListener(event, handler, false);
        } else if (obj.detachEvent) {
            obj.detachEvent('on' + event, handler);
        }
    }

    function displayFaqPopupText(el, newFaqString, faqContainerWidth) {
        let oldPos = '';
        if ((el.tagName === 'A') && navigator.appVersion.indexOf('MSIE') !== -1) {
            oldPos = el.style.position;
            el.style.position = 'relative';
        }
        const elPos = window.findPos(el);
        if ((el.tagName === 'A') && navigator.appVersion.indexOf('MSIE') !== -1) el.style.position = oldPos;
        if (document.getElementById('faqContainer') == null || document.getElementById('faqContainer') == null) {
            let faqHeader = '<table border="0" cellpadding="0" cellspacing="0" width="100%" class="faqPopupHeader"><tr>';
            faqHeader += '<td><a class="proplink closeBtn js-hide-faq-popup" href="#"><span>close</span><svg class="icon icon-delete"><use xlink:href="/images/icon/icon-junior.svg#icon-delete"></use></svg></a></td></tr></table>';
            const faqContainer = document.createElement('div');
            faqContainer.setAttribute('id', 'faqContainer');
            faqContainer.innerHTML = faqHeader;
            const faqHolder = document.createElement('div');
            faqHolder.setAttribute('id', 'faqHolder');
            faqContainer.appendChild(faqHolder);
            document.body.appendChild(faqContainer);
            $('.js-hide-faq-popup').on('click', function () {
                hideFaqPopup();
                return false;
            });

            $(document).unbind('keyup.popupFaqCloser');
            $(document).bind('keyup.popupFaqCloser', function (e) {
                if (e.keyCode == 27) {
                    hideFaqPopup();
                }
            });

            $(document).unbind('click.popupFaqCloser');
            $(document).bind('click.popupFaqCloser', function (e) {
                const evt = (e) || event;
                const theElem = (evt.srcElement) ? evt.srcElement : evt.target;
                if ($(theElem).closest('#faqContainer').length === 0) {
                    hideFaqPopup();
                }
                return true;
            });
        }
        // var newFaqString = getContentDocument("faqFrame").body.innerHTML;
        document.getElementById('faqHolder').innerHTML = newFaqString;
        document.getElementById('faqContainer').style.width = faqContainerWidth + 'px';
        if (elPos[0] + faqContainerWidth < document.body.clientWidth) {
            document.getElementById('faqContainer').style.left = (elPos[0] - 10) + 'px';
        } else {
            document.getElementById('faqContainer').style.left = (document.body.clientWidth - faqContainerWidth - 20) + 'px';
        }
        document.getElementById('faqContainer').style.top = (elPos[1]) + 'px';

        const faqTopY = (elPos[1]);
        let browserHeight;
        let browserTopY;
        if (document.documentElement && document.documentElement.scrollTop) {
            browserTopY = document.documentElement.scrollTop;
        } else {
            browserTopY = document.body.scrollTop;
        }
        if (typeof (window.innerHeight) === 'number') {
            browserHeight = window.innerHeight;
        } else {
            browserHeight = document.documentElement.clientHeight;
        }

        document.getElementById('faqContainer').style.display = 'block';
        const faqHeight = document.getElementById('faqContainer').offsetHeight;

        if (faqHeight + faqTopY > browserHeight + browserTopY) {
            document.getElementById('faqContainer').style.top = (browserHeight + browserTopY - faqHeight) + 'px';
        }
    }

    function displayFaqPopup(el, faqContainerWidth) {
        if (window.getContentDocument('faqFrame') != null && trim(window.getContentDocument('faqFrame').body.innerHTML) == '') {
            setTimeout(createFaqPopupClosure(el), 500);
        } else {
            displayFaqPopupText(el, window.getContentDocument('faqFrame').body.innerHTML, faqContainerWidth);
        }
    }

    function hideFaqPopup() {
        document.getElementById('faqContainer').style.display = 'none';
    }
})();
